const TextInput = ({
                     label,
                     name,
                     type = "text",
                     required,
                     value,
                     isTouch = true,
                     isValid,
                     message,
                     onChange,
                     onBlur,
                     placeholder,
                     side,
                     isDisabled = false,
                     maxLength = 30,
                     showCount = false,
                   }) => {

  // 에러 메시지 노출 조건
  const showError = isTouch && !isValid;

  return (
    <div className={`field ${showError ? "negative" : ""}`}>
      <label>
        {label}
        {required &&
          <span className="required" aria-hidden="true">*</span>
        }
      </label>
      <div className="input-wrap">
        <div className="input-box">
          <input
            className="input-inner"
            type={type}
            placeholder={placeholder}
            name={name}
            value={value}
            onChange={onChange}
            onBlur={onBlur}
            disabled={isDisabled}
            maxLength={maxLength}
          />
        </div>
        {side && <>{side}</>}
        {(showError || showCount) &&
          <div className="message-box">
            {showError && <span className="message">{message}</span>}
            {showCount && <span className="text-count">{(value || "").length}/{maxLength}</span>}
          </div>
        }
      </div>
    </div>

  );
};

export default TextInput;
